import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateFormFailure,
  CreateFormRequest,
  CreateFormSuccess,
  DeleteFormFailure,
  DeleteFormRequest,
  DeleteFormSuccess,
  FetchFormFailure,
  FetchFormRequest,
  FetchFormSuccess,
  FetchFormsFailure,
  FetchFormsRequest,
  FetchFormsSuccess,
  UpdateFormFailure,
  UpdateFormRequest,
  UpdateFormSuccess,
} from './forms.actions'
import { FormsService } from './forms.service'
import * as FormsTypes from './forms.types'

@Injectable()
export class FormsEffects {
  constructor(
    private actions: Actions,
    private formsService: FormsService,
    private router: Router,
  ) {}

  FetchForms$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormsTypes.FETCH_FORMS_REQUEST),
      switchMap((action: FetchFormsRequest) => {
        return this.formsService.fetchForms(action.payload).pipe(
          map((result) => {
            return new FetchFormsSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchFormsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchForm$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormsTypes.FETCH_FORM_REQUEST),
      switchMap((action: FetchFormRequest) => {
        return this.formsService.fetchForm(action.id).pipe(
          map((result) => {
            return new FetchFormSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchFormFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteForm$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormsTypes.DELETE_FORM_REQUEST),
      switchMap((action: DeleteFormRequest) => {
        return this.formsService.deleteForm(action.id).pipe(
          switchMap((result) => {
            return [new DeleteFormSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteFormFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateForm$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormsTypes.CREATE_FORM_REQUEST),
      switchMap((action: CreateFormRequest) => {
        return this.formsService.createForm(action.payload).pipe(
          switchMap((result) => {
            if (action.redirect) {
              this.router.navigate(['/admin/forms'])
            } else {
              this.router.navigate(['/admin/forms', result.data.id, 'update'])
            }
            return [new CreateFormSuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateFormFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateForm$ = createEffect(() =>
    this.actions.pipe(
      ofType(FormsTypes.UPDATE_FORM_REQUEST),
      switchMap((action: UpdateFormRequest) => {
        return this.formsService.updateForm(action.id, action.payload).pipe(
          switchMap((result) => {
            if (action.redirect) {
              this.router.navigate(['/admin/forms'])
            }
            return [new UpdateFormSuccess()]
          }),
          catchError((err, caught) => {
            return of(new UpdateFormFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
